import React, { useState } from "react";
import { useEffect } from "react";
import {
  ActivateCustomer,
  AdminOneCustomer,
  AdminViewSingleOrder,
  AdminViewSingleOrderByUserId,
  DeactivateCustomer,
} from "../utils/Api/ApiCalls";
import { useParams } from "react-router-dom";

const CustomerDetail = () => {
  const { customerId } = useParams();
  const [customerData, setCustomerData] = useState([]);
  const [customerOrders, setCustomerOrders] = useState([]);
  const [totalPurchase, setTotalPurchase] = useState("--");

  useEffect(() => {
    const getCustomers = async () => {
      const customerDetails = await AdminOneCustomer(customerId);
      setCustomerData(customerDetails);

      const customerOrders = await AdminViewSingleOrderByUserId(customerId);
      setCustomerOrders(customerOrders?.data);

      // Calculate total purchases....
      var totalPurchase = 0;
      if (customerOrders?.data) {
        for (let index = 0; index < customerOrders.data.length; index++) {
          totalPurchase += customerOrders.data[index].totalPrice;
        }
      }
      setTotalPurchase(totalPurchase);
    };
    getCustomers();
  }, [customerId]);
  const handleBackClick = () => {
    window.history.back();
  };

  const parseAmount = (total) => {
    return total.toLocaleString();
  };

  const deactivateAccount = async (userId) => {
    const response = await DeactivateCustomer(userId);
    if (response.status === 201) {
      setCustomerData((prevData) => ({
        ...prevData,
        isActive: 0,
      }));
    }
    
  };

  const activateAccount = async (userId) => {
    const response = await ActivateCustomer(userId);
    if (response.status === 201) {
      setCustomerData((prevData) => ({
        ...prevData,
        isActive: 1,
      }));
    }
    
  };

  const OrdersList = ({ data }, index) => {
    return (
      <div className="col-xl-2 col-lg-3 col-md-6" key={index}>
        <div className="card card-product-grid">
          <a href="#" className="img-wrap">
            <img
              src={`/uploads/${data.image}`}
              alt="Product"
            />
          </a>
          <div className="info-wrap">
            <a href="#" className="title">
              {data.productName}
            </a>
            <div className="price mt-1">₦{parseAmount(data.totalPrice)}</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className="content-main">
      <div className="content-header">
        <button
          onClick={handleBackClick}
          className="btn-back back-button-style"
        >
          <i className="material-icons md-arrow_back"></i> Go back
        </button>
      </div>
      <div className="card mb-4">
        <div
          className="card-header bg-brand-2"
          style={{ height: "150px" }}
        ></div>
        <div className="card-body">
          <div className="row">
            <div
              className="col-xl col-lg flex-grow-0"
              style={{ flexBasis: "230px" }}
            >
              <div
                className="img-thumbnail d-flex align-items-center justify-content-center shadow w-100 bg-white position-relative text-center"
                style={{ height: "190px", width: "200px", marginTop: "-120px" }}
              >
                {/* <img
                  src={`https://backend.argone.ng/uploads/${customerData?.image}`}
                  className="center-xy img-fluid"
                  alt="Logo Brand"
                /> */}
                <p
                 style={{ color: "#8E8E93", fontSize: "5.5rem"}}
                 >{customerData?.userProfile?.firstName[0] + customerData?.userProfile?.lastName[0]}</p>
              </div>
            </div>
            {/* col */}
            <div className="col-xl col-lg">
              <h3>{customerData.fullname}</h3>
              <p>{customerData?.userProfile?.address}</p>
            </div>
            {/* col */}
            {customerData?.isActive === 0 ? (
              <div
                onClick={() => activateAccount(customerData?.id)}
                className="col-xl-4 text-md-end"
              >
                <a href="#" className="btn btn-success">
                  Activate Customer
                </a>
              </div>
            ) : (
              <div
                onClick={() => deactivateAccount(customerData?.id)}
                className="col-xl-4 text-md-end"
              >
                <a href="#" className="btn btn-danger">
                  Deactivate Customer
                </a>
              </div>
            )}
            {/* col */}
          </div>
          {/* card-body */}
          <hr className="my-4" />
          <div className="row g-4">
            <div className="col-md-12 col-lg-4 col-xl-4">
              <article className="box">
                <p className="mb-0 text-muted">Number of purchase:</p>
                <h5 className="text-success">
                  {customerOrders ? customerOrders.length : 0}
                </h5>
                <p className="mb-0 text-muted">Total purchase:</p>
                <h5 className="text-success mb-0">
                  ₦ {parseAmount(totalPurchase)}
                </h5>
              </article>
            </div>
            {/* col */}
            <div className="col-sm-6 col-lg-4 col-xl-4">
              <h6>Contacts</h6>
              <p>
                {customerData.email} <br />
                {customerData?.userProfile?.phoneNum}
              </p>
            </div>
            {/* col */}
            <div className="col-sm-6 col-lg-4 col-xl-4">
              <h6>Address</h6>
              <p>
                {customerData?.userProfile?.country ? (
                  <>
                    Country: {customerData.userProfile.country} <br />
                  </>
                ) : (
                  <>
                    No country information <br />
                  </>
                )}
                {customerData?.userProfile?.address ? (
                  <>
                    Country: {customerData.userProfile.address} <br />
                  </>
                ) : (
                  <>
                    No address information <br />
                  </>
                )}
                {customerData?.userProfile?.postalCode ? (
                  <>
                    Country: {customerData.userProfile.postalCode} <br />
                  </>
                ) : (
                  <>
                    No postal code information <br />
                  </>
                )}
              </p>
            </div>
            {/* col */}
          </div>
          {/* row */}
        </div>
        {/* card-body */}
      </div>
      {/* card */}
      <div className="card mb-4">
        <div className="card-body">
          <h3 className="card-title">Orders</h3>
          <div className="row">
            {customerOrders?.length ? (
              customerOrders.map((data, index) => (
                <OrdersList data={data} index={index} />
              ))
            ) : (
              <>No orders ...</>
            )}
          </div>
          {/* row */}
        </div>
        {/* card-body */}
      </div>
      {/* card */}
      {/* <div className="pagination-area mt-30 mb-50">
        <nav aria-label="Page navigation example">
          <ul className="pagination justify-content-start">
            <li className="page-item active">
              <a className="page-link" href="#">
                01
              </a>
            </li>
            <li className="page-item">
              <a className="page-link" href="#">
                02
              </a>
            </li>
            <li className="page-item">
              <a className="page-link" href="#">
                03
              </a>
            </li>
            <li className="page-item">
              <a className="page-link dot" href="#">
                ...
              </a>
            </li>
            <li className="page-item">
              <a className="page-link" href="#">
                16
              </a>
            </li>
            <li className="page-item">
              <a className="page-link" href="#">
                <i className="material-icons md-chevron_right"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div> */}
    </section>
  );
};

export default CustomerDetail;
